export const RouterName = {
  WELCOME: 'welcome',
  HOME: 'home',
  LOGIN: 'login',
  NOT_FOUND: '404',
  NOT_HAVE_PERMISSION: '403',

  //PROJECT-MANAGEMENT
  PROJECT_MANAGEMENT: 'project-management',
  PROJECT_LIST: 'project-management.project-list',
  PROJECT_DETAIL: 'project-management.project-list.detail',

  //ASSET_MANAGEMENT
  ASSET_MANAGEMENT: 'asset-management',
  ASSET_HIER_TREE: 'asset-management.asset-hier-tree',
  ASSET_MODEL: 'asset-management.asset-model',
  ASSET_MODEL_DETAIL: 'asset-management.asset-model.detail',
  ASSET_GROUP: 'asset-management.asset-group',
  ASSET: 'asset-management.asset',
  ASSET_DETAIL: 'asset-management.asset.detail',
  INVENTORY_ITEM: 'asset-management.inventory-item',

  //ARISING_REPAIR
  ARISING_REPAIR: 'arising-repair',

  //PERIODIC_MAINTENANCE
  PERIODIC_MAINTENANCE: 'periodic-maintenance',
  MAINTENANCE_PLAN: 'periodic-maintenance.maintenance-plan',

  //TASK_MANAGEMENT
  TASK_MANAGEMENT: 'task-management',

  //REPORT
  REPORT: 'report'
}
export const UriRole = {
  //ASSET_MANAGEMENT
  ASSET_MANAGEMENT: 'asset_management',
  ASSET_HIER_TREE: '/asset-hier',
  INVENTORY_ITEM: '/invt-item',

  //ASSET_MODEL
  ASSET_MODEL: '/asset-model',

  //ASSET
  ASSET: '/asset',

  //PROJECT_MANAGEMENT
  PROJECT_MANAGEMENT: 'project-management',
  ASSET_GROUP: '/asset-group',
  PROJECT_LIST: '/project-list'
}
